import { render, staticRenderFns } from "./FirstLogin.vue?vue&type=template&id=5fb66a9f&scoped=true"
import script from "./FirstLogin.vue?vue&type=script&lang=js"
export * from "./FirstLogin.vue?vue&type=script&lang=js"
import style0 from "./FirstLogin.vue?vue&type=style&index=0&id=5fb66a9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb66a9f",
  null
  
)

export default component.exports